import ExpandedSection from './ExpandedSection';
import './resourcesSection.css';

export type ResourceLinks = {
  label: string;
  href: string;
};

type ResourcesSectionProps = {
  chevronSrc: string;
  resources: ReadonlyArray<ResourceLinks>;
  externalLinkIconSrc: string;
};

export default function ResourcesSection({
  chevronSrc,
  resources,
  externalLinkIconSrc,
}: ResourcesSectionProps) {
  return (
    <ExpandedSection title="Resources" chevronSrc={chevronSrc} testId="landing-resources-toggle" cardClassName="rid-resources-section">
      {/* Position is the stable identity here: this list is fixed per market and is never filtered or sorted. */}
      {resources.map(({ label, href }, i) => (
        <a
          key={`${label}-${href}-${i}`}
          className="rid-resources-section__link"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${label} (opens in a new tab)`}
          data-testid={`landing-resource-${i + 1}`}
        >
          <span>{label}</span>
          <img src={externalLinkIconSrc} alt="" aria-hidden="true" />
        </a>
      ))}
    </ExpandedSection>
  );
}
